export default "__VITE_ASSET__CUTZ05dw__"